import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VueFullPage from 'vue-fullpage.js';
import App from './App.vue';
import router from './router';
import 'animate.css';


Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(VueFullPage);


new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
